import { Color, HexColor } from '../Enum/Color';
import { Rule as AcceptanceFeatureRule } from '../Interface/Response/Validator/Results/Review/Response/Rule';
import { getHexColorByResult } from './Color';

const getIndexByHexColor = (result: HexColor): number => {
    switch (result) {
        case HexColor.Green:
            return 4;
        case HexColor.Orange:
            return 2;
        case HexColor.Red:
            return 1;
        case HexColor.Blue:
            return 3;
        default:
            return 5;
    }
};

const getIndexByResult = (resultaat: Color | null): number => getIndexByHexColor(getHexColorByResult(resultaat));

export const sortByColor = (a: { color: HexColor }, b: { color: HexColor }): number =>
    getIndexByHexColor(a.color) - getIndexByHexColor(b.color);

export const sortAcceptanceFeatures = (a: AcceptanceFeatureRule, b: AcceptanceFeatureRule): number => {
    if (getIndexByResult(a.resultaat) === getIndexByResult(b.resultaat)) {
        return a.referentie.localeCompare(b.referentie);
    }
    return getIndexByResult(a.resultaat) - getIndexByResult(b.resultaat);
};
